/**
 * Converts minor units (cents) to major units (dollars)
 */
export function minorToMajor(minorUnits: number): number {
  return minorUnits / 100;
}

/**
 * Converts major units (dollars) to minor units (cents)
 */
export function majorToMinor(majorUnits: number): number {
  return Math.round(majorUnits * 100);
}
